import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import CtaBar from '~/components/blocks/acf/CtaBar';

import { backgroundColors } from '~/theme';

const CtaBarBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockCtaBar: {
        variant,
        backgroundColor,
        title,
        leftTitle,
        rightTitle,
        ctas
    }
}) => (
    <CtaBar
        {...{
            variant,
            backgroundColor,
            title,
            leftTitle,
            rightTitle,
            ctas,
            globalBlockOptions,
            attributes
        }}
    />
);

CtaBarBlock.propTypes = {
    blockCtaBar: PropTypes.shape({
        variant: PropTypes.string,
        backgroundColor: PropTypes.oneOf(Object.keys(backgroundColors)),
        title: PropTypes.string,
        leftTitle: PropTypes.string,
        rightTitle: PropTypes.string,
        ctas: PropTypes.arrayOf(
            PropTypes.shape({
                copy: PropTypes.string,
                link: PropTypes.shape({
                    url: PropTypes.string.isRequired,
                    title: PropTypes.string
                }),
                useComparisonTable: PropTypes.bool,
                comparisonTableProductCategory: PropTypes.shape({
                    id: PropTypes.string
                })
            })
        )
    }).isRequired
};

export default CtaBarBlock;

export const fragment = graphql`
    fragment CtaBarBlockFragment on WpAcfCtaBarBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockCtaBar {
            variant
            backgroundColor
            title
            leftTitle
            rightTitle
            ctas {
                copy
                link {
                    url
                    title
                }
                useComparisonTable
                comparisonTableProductCategory {
                    id
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Single Column CTA Bar',
        description:
            'Background Color may be red or blue. Accepts an optional title and any number of Button CTAs.',
        props: {
            name: 'acf/cta-bar',
            blockCtaBar: {
                variant: 'singleColumn',
                backgroundColor: 'red',
                title: 'Have an Unlimited Plan? Add a wash to your account here, or through the Autobell app.',
                ctas: [
                    {
                        link: {
                            url: '#1',
                            title: 'Add a Wash Now'
                        }
                    }
                ]
            }
        }
    },
    {
        variant: 'Three Column Arrows CTA Bar',
        description:
            'Background Color may be red or blue. Accepts an optional title and any number of Arrow CTAs with optional title, link, copy.',
        props: {
            name: 'acf/cta-bar',
            blockCtaBar: {
                variant: 'threeColumn',
                backgroundColor: 'blue',
                ctas: [
                    {
                        link: {
                            url: '#2',
                            title: 'Company Profile'
                        },
                        copy: 'Learn more about Autobell® Car Wash.'
                    },
                    {
                        link: {
                            url: '#3',
                            title: 'Media Resources'
                        },
                        copy: 'Create stories through our suite of assets.'
                    },
                    {
                        link: {
                            url: '#4',
                            title: 'Biographies'
                        },
                        copy: 'Learn about our executive team.'
                    }
                ]
            }
        }
    },
    {
        variant: 'Find Your Car Wash CTA Bar',
        description:
            'Background Color may be red or blue. Left Column will display the Car Wash search feature, Right Column will display title with CTAs. Accepts an optional top title, left title, right title and any number of Button CTAs.',
        props: {
            name: 'acf/cta-bar',
            blockCtaBar: {
                variant: 'findYourCarWash',
                backgroundColor: 'blue',
                leftTitle: 'Find Your Car Wash',
                rightTitle: 'Have a question?',
                ctas: [
                    {
                        link: {
                            url: '#5',
                            title: 'Contact Us'
                        }
                    },
                    {
                        link: {
                            url: '#6',
                            title: 'Autobell FAQs'
                        }
                    }
                ]
            }
        }
    }
];
